module.exports = __webpack_public_path__ + "img/79.7.Chla.b566edf7.png";